const teamMember = [
  {
    name: "Ashwanee Gupta",
    title: "Graphics Designer / UI Developer",
    photoURL:
      "https://firebasestorage.googleapis.com/v0/b/inspire-graphics.appspot.com/o/users%2FBd3o0M0o1YUKVVoczU1AAkodnRO2.jpeg?alt=media&token=3cfce532-e352-4458-8e00-c7c07ec97ea3",
    description:
      "A full-stack UI developer & Graphic designer, with 3+ year of experience in programming, & designing.",
    social: [
      {
        label: "facebook",
        link: "https://www.facebook.com/guptaashwanee",
        icon: "fab fa-facebook-f",
        anchorClass: "fb-ic",
      },
      {
        label: "twitter",
        link: "https://www.twitter.com/guptaashwanee",
        icon: "fab fa-twitter",
        anchorClass: "tw-ic",
      },
      {
        label: "github",
        link: "https://www.github.com/guptaashwanee",
        icon: "fab fa-github",
        anchorClass: "git-ic",
      },
      {
        label: "dribbble",
        link: "https://www.dribbble.com/guptaashwanee",
        icon: "fab fa-dribbble",
        anchorClass: "dribbble-ic",
      },
      {
        label: "linkedIn",
        link: "https://www.linkedin.com/in/guptaashwanee/",
        icon: "fab fa-linkedin-in",
        anchorClass: "li-ic",
      },
      {
        label: "instagram",
        link: "https://www.instagram.com/guptaashwanee",
        icon: "fab fa-instagram",
        anchorClass: "ins-ic",
      },
      {
        label: "mail",
        link:
          "https://mail.google.com/mail/?view=cm&fs=1&to=ashwanee2001gupta@gmail.com&su=INFO @ INSPIRE GRAPHICS &body=Hi there Inspire Graphics....&bcc=info.inspirecg@gmail.com",
        icon: "fas fa-envelope",
        anchorClass: "yt-ic",
      },
    ],
  },
  {
    name: "Abhishek Rai",
    title: "Photoshop Expert / UI Designer",
    photoURL:
      "https://firebasestorage.googleapis.com/v0/b/inspire-graphics.appspot.com/o/team%2FAbhishek%20Rai.jpg?alt=media&token=19156058-1b58-4611-a4ef-4b3f155c072f",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quod eos id officiis hic tenetur.",
    social: [
      {
        label: "facebook",
        link: "https://www.facebook.com/realabhirai",
        icon: "fab fa-facebook-f",
        anchorClass: "fb-ic",
      },
      {
        label: "twitter",
        link: "https://twitter.com/realabhishekrai",
        icon: "fab fa-twitter",
        anchorClass: "tw-ic",
      },
      {
        label: "github",
        link: "https://github.com/realabhishekrai",
        icon: "fab fa-github",
        anchorClass: "git-ic",
      },

      {
        label: "linkedIn",
        link: "https://www.linkedin.com/in/abhishek-rai-6a6a90181/",
        icon: "fab fa-linkedin-in",
        anchorClass: "li-ic",
      },
      {
        label: "instagram",
        link: "https://www.instagram.com/realabhishekrai/",
        icon: "fab fa-instagram",
        anchorClass: "ins-ic",
      },
      {
        label: "mail",
        link: "mailto:realabhishekrai@gmail.com",
        icon: "fas fa-envelope",
        anchorClass: "yt-ic",
      },
    ],
  },
  {
    name: "Ankit Singh Chauhan",
    title: "UI Developer / Content Creator",
    photoURL:
      "https://firebasestorage.googleapis.com/v0/b/inspire-graphics.appspot.com/o/team%2FAnkit%20Singh%20Chauhan.jpg?alt=media&token=dd86301e-c749-438c-9e67-7577e6ec2eff",
    description: "I am a front-End developer / UI designer and programmer.",
    social: [
      {
        label: "facebook",
        link: "https://www.facebook.com/ankitt0007",
        icon: "fab fa-facebook-f",
        anchorClass: "fb-ic",
      },
      {
        label: "twitter",
        link: "https://twitter.com/Itz_Trooper_",
        icon: "fab fa-twitter",
        anchorClass: "tw-ic",
      },
      {
        label: "github",
        link: "https://github.com/ItzTrooper009",
        icon: "fab fa-github",
        anchorClass: "git-ic",
      },
      {
        label: "linkedIn",
        link: "https://www.linkedin.com/in/ankitt-chouhann-382459126/",
        icon: "fab fa-linkedin-in",
        anchorClass: "li-ic",
      },
      {
        label: "instagram",
        link: "https://www.instagram.com/itz_trooper_/",
        icon: "fab fa-instagram",
        anchorClass: "ins-ic",
      },
      {
        label: "mail",
        link: "mailto:ankitt335407@gmail.com",
        icon: "fas fa-envelope",
        anchorClass: "yt-ic",
      },
    ],
  },
  {
    name: "Nitin Singh",
    title: "Graphics Designer",
    photoURL:
      "https://firebasestorage.googleapis.com/v0/b/inspire-graphics.appspot.com/o/team%2FNitin%20Singh.jpg?alt=media&token=6234f440-7394-4717-991d-a42a731451f3",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quod eos id officiis hic tenetur.",
    social: [
      {
        label: "facebook",
        link: "https://www.facebook.com/profile.php?id=100024403882912",
        icon: "fab fa-facebook-f",
        anchorClass: "fb-ic",
      },
      {
        label: "linkedIn",
        link: "https://www.linkedin.com/in/nitin-singh-1885b2158/",
        icon: "fab fa-linkedin-in",
        anchorClass: "li-ic",
      },
      {
        label: "instagram",
        link: "https://www.instagram.com/singhnitin_27/",
        icon: "fab fa-instagram",
        anchorClass: "ins-ic",
      },
      {
        label: "mail",
        link: "mailto:nitinsinghji12@gmail.com",
        icon: "fas fa-envelope",
        anchorClass: "yt-ic",
      },
      // {
      //   label: "mail",
      //   link: "mailto:nitinsinghji12@gmail.com",
      //   icon: "fas fa-envelope",
      //   anchorClass: "email-ic",
      // },
    ],
  },
];
const ourServices = [
  {
    title: "WEB DESIGN",
    description:
      "Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente earu proident. Ad vegan excepteur butcher vice lomo leggings.",
    href: "#/",
  },
  {
    title: "GRAPHICS DESIGN",
    description:
      "Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente earu proident. Ad vegan excepteur butcher vice lomo leggings.",
    href: "#/",
  },
  {
    title: "DEVELOPMENT",
    description:
      "Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente earu proident. Ad vegan excepteur butcher vice lomo leggings.",
    href: "#/",
  },
  {
    title: " MULTIMEDIA / ANIMATION",
    description:
      "Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente earu proident. Ad vegan excepteur butcher vice lomo leggings.",
    href: "#/",
  },
];
const awesomeFeatures = [
  {
    col: [
      {
        title: "Modern design",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Reprehenderit maiores nam, aperiam minima.",
        icon: "fas fa-edit",
      },
      {
        title: "Easy for learn",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Reprehenderit maiores nam, aperiam minima.",
        icon: "fas fa-cogs",
      },
      {
        title: "Responsive work",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Reprehenderit maiores nam, aperiam minima.",
        icon: "fas fa-tablet-alt",
      },
    ],
  },
  {
    col: [
      {
        type: "image",
        src:
          "https://mdbootstrap.com/img/Mockups/Transparent/Small/admin-new.png",
      },
    ],
  },
  {
    col: [
      {
        title: "Optimized for use",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Reprehenderit maiores nam, aperiam minima.",
        icon: "fas fa-chart-line",
      },
      {
        title: "Technical support",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Reprehenderit maiores nam, aperiam minima.",
        icon: "fas fa-users",
      },
      {
        title: "High quality",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Reprehenderit maiores nam, aperiam minima.",
        icon: "far fa-gem",
      },
    ],
  },
];
const socialLink = [
  {
    label: "github",
    href: "https://github.com/guptaashwanee",
    icon: "fab fa-github",
    color: "gplus-ic",
  },
  {
    label: "linkedin",
    href: "https://www.linkedin.com/in/guptaashwanee/",
    icon: "fab fa-linkedin-in",
    color: "li-ic",
  },
  {
    label: "twitter",
    href: "https://twitter.com/guptaashwanee",
    icon: "fab fa-twitter",
    color: "tw-ic",
  },
  {
    label: "facebook",
    href: "https://www.facebook.com/guptaashwanee",
    icon: "fab fa-facebook-f",
    color: "fb-ic",
  },
  {
    label: "instagram",
    href: "https://www.instagram.com/guptaashwanee/",
    icon: "fab fa-instagram",
    color: "li-ic",
  },
];

const getSocialLink = () => {
  return socialLink;
};

const getTeamMember = () => {
  return teamMember;
};
const getOurServices = () => {
  return ourServices;
};
const getFeatures = () => {
  return awesomeFeatures;
};
const setTheme = (theme) => {
  localStorage.setItem("theme", theme);
};
const getTheme = () => {
  return localStorage.getItem("theme");
};

export default {
  getTeamMember,
  getOurServices,
  getFeatures,
  setTheme,
  getTheme,
  getSocialLink,
};
